import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useSubjectPlans(data = {}) {
  const { enabled = true, classID = '', configs = {} } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getSubjectPlans() {
    return privateFetch.get(`/v1/admin/class/${classID}/plan`, configs).then((res) => res.data);
  }

  return useQuery(['class-subject-plans', classID], getSubjectPlans, { enabled });
}

export default useSubjectPlans;
